import UpdateBar, {IUpdateBar} from '@wearesection/bandai-react-components/organisms/UpdateBar';
import React from 'react';
import {ComponentPropsAdapter} from '../../types';
import {News} from '~/graphql/types';

type IUpdateBarExt = IUpdateBar & {
  events: News[];
};

const adapter: ComponentPropsAdapter<IUpdateBarExt, IUpdateBar> = data => {
  return {
    title: data?.title ?? '',
    events:
      data?.events?.map((item: News | any) => {
        return {
          title: item?.title ?? '',
          date: item?.date ?? '',
        };
      }) ?? [],
    viewMore: data?.viewMore,
  };
};

const UpdateBarOrganisms: React.FC<IUpdateBarExt> = props => {
  const componentProps = adapter(props);
  return <UpdateBar {...componentProps} />;
};

export default UpdateBarOrganisms;
